// frontend/src/analytics/RouteAnalyticsGA.jsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const DASH = new Map([
  ["/steam", "Steam"],
  ["/mindshare", "mindSHARE"],
  ["/tiktok", "TikTok"],
  ["/mobile", "Mobile"],
  ["/calendar", "Calendar"],
  ["/page-access", "Page Access"],
]);

export default function RouteAnalyticsGA() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!window.gtag) return;

    // 1) regular SPA page view
    window.gtag("event", "page_view", {
      page_path: pathname + (search || ""),
      page_title: document.title,
    });

    // 2) optional: top-level dashboard event
    const top = "/" + (pathname.split("/")[1] || "");
    const name = DASH.get(top);
    if (name) {
      window.gtag("event", "dashboard_view", { dashboard_name: name });
    }
  }, [pathname, search]);

  return null;
}
